<template>
  <b-modal
    :visible="updateFound"
    centered
    hide-footer
    hide-header-close
    hide-header
    no-close-on-backdrop
    no-close-on-esc
    no-stacking
    modal-class="update-modal-modern"
    body-class="update-modal-body"
  >
    <div class="update-container">
      <!-- Atualizado -->
      <template v-if="updateReady">
        <div class="update-content success">
          <div class="update-icon success-icon">
            <i class="fas fa-check-circle"></i>
          </div>
          <div class="update-text">
            <h3 class="update-title">Sistema Atualizado!</h3>
            <p class="update-message">Obrigado por aguardar. Reiniciando...</p>
          </div>
          <div class="update-indicator">
            <div class="success-pulse"></div>
          </div>
        </div>
      </template>

      <!-- Atualização em andamento -->
      <template v-else>
        <div class="update-content updating">
          <div class="update-icon updating-icon">
            <i class="fas fa-download"></i>
          </div>
          <div class="update-text">
            <h3 class="update-title">Atualizando Sistema</h3>
            <p class="update-message">
              Por favor, aguarde. Não feche esta janela.
            </p>
          </div>
          <div class="update-progress">
            <div class="progress-bar">
              <div class="progress-fill"></div>
            </div>
            <div class="progress-dots">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "UpdateAlert",

  data() {
    return {
      updateFound: false,
      updateReady: false,
    };
  },

  created() {
    window.addEventListener("pwa-update-found", () => {
      this.updateFound = true;
    });

    window.addEventListener("pwa-update-ready", () => {
      this.updateReady = true;

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
  },
};
</script>

<style scoped>
/* Modal Styling */
.update-modal-modern >>> .modal-dialog {
  max-width: 450px !important;
  margin: 1.75rem auto !important;
}

.update-modal-modern >>> .modal-content {
  border: none !important;
  border-radius: 20px !important;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3) !important;
  overflow: hidden !important;
  background: transparent !important;
}

.update-modal-body {
  padding: 0 !important;
  background: transparent !important;
}

/* Container */
.update-container {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  padding: 40px 32px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.update-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
      circle at 20% 80%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 20%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 50%
    );
  pointer-events: none;
}

/* Content Layout */
.update-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

/* Icon Styling */
.update-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: white;
  position: relative;
  transition: all 0.3s ease;
}

.updating-icon {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  animation: pulse-updating 2s infinite;
}

.success-icon {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  box-shadow: 0 8px 32px rgba(16, 185, 129, 0.4);
  animation: bounce-success 0.6s ease-out;
}

/* Text Styling */
.update-text {
  color: white;
  max-width: 320px;
}

.update-title {
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 8px 0;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.update-message {
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  opacity: 0.9;
  line-height: 1.4;
}

/* Progress Indicators */
.update-progress {
  width: 100%;
  max-width: 280px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.progress-bar {
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #34d399 0%, #10b981 100%);
  border-radius: 2px;
  animation: progress-fill 3s infinite;
}

.progress-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  animation: dot-bounce 1.4s infinite;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

/* Success Indicator */
.update-indicator {
  width: 100%;
  display: flex;
  justify-content: center;
}

.success-pulse {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  animation: success-pulse 1.5s infinite;
}

/* Animations */
@keyframes pulse-updating {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 20px rgba(255, 255, 255, 0);
  }
}

@keyframes bounce-success {
  0% {
    transform: scale(0.3);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes progress-fill {
  0% {
    width: 0%;
    transform: translateX(-100%);
  }
  50% {
    width: 100%;
    transform: translateX(0%);
  }
  100% {
    width: 100%;
    transform: translateX(100%);
  }
}

@keyframes dot-bounce {
  0%,
  80%,
  100% {
    transform: scale(1);
    opacity: 0.4;
  }
  40% {
    transform: scale(1.3);
    opacity: 1;
  }
}

@keyframes success-pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Responsive Design */
@media (max-width: 480px) {
  .update-modal-modern >>> .modal-dialog {
    max-width: 340px !important;
    margin: 1rem auto !important;
  }

  .update-container {
    padding: 32px 24px;
  }

  .update-icon {
    width: 70px;
    height: 70px;
    font-size: 28px;
  }

  .update-title {
    font-size: 20px;
  }

  .update-message {
    font-size: 14px;
  }

  .progress-bar {
    height: 3px;
  }

  .dot {
    width: 6px;
    height: 6px;
  }

  .success-pulse {
    width: 50px;
    height: 50px;
  }
}

/* Dark mode considerations */
@media (prefers-color-scheme: dark) {
  .update-container {
    background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  }
}

/* High contrast mode */
@media (prefers-contrast: high) {
  .update-container {
    background: #1e293b;
  }

  .update-icon {
    border: 3px solid white;
  }

  .update-title,
  .update-message {
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
  }
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .updating-icon,
  .progress-fill,
  .dot,
  .success-pulse {
    animation: none;
  }

  .success-icon {
    animation: none;
    transform: scale(1);
  }
}
</style>